<template>
  <div class="notification">
    <div class="notification__close" @click="$emit('close')">
      <close-icon classes="chat-icon-trigger svg-block" />
    </div>
    <div class="notification__content">
      <slot />
    </div>
  </div>
</template>

<script>
// @flow

import CloseIcon from '../Icons/CloseIcon.vue'

export default {
  components: {
    CloseIcon
  }
}
</script>

<style src="./notification.scss">
